import { useLocation } from "react-router-dom";
import * as S from "../styles/HeaderStyles";

const Header = ({ menuItems }) => {
  const location = useLocation();
  const currentPath = location.pathname;

  // Find the menu item that matches the current path
  const currentMenuItem = menuItems.find((item) => item.path === currentPath);

  // Use the label and icon from the menu item, or fallback if not found
  const pageTitle = currentMenuItem ? currentMenuItem.label : "Page Not Found";
  const pageIcon = currentMenuItem ? currentMenuItem.icon : null;

  return (
    <S.Header>
      <S.TitleContainer>
        {pageIcon && <S.Icon>{pageIcon}</S.Icon>}
        <S.Title>{pageTitle}</S.Title>
      </S.TitleContainer>
    </S.Header>
  );
};

export default Header;